import { api } from "@/core/api/";

export default {
    getAppointmentsFilters(properties) {
        return api.get("api/appointment/monthsAvailable", {
            params: {
                ...properties
            }
        });
    },

}